import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import settings from 'settings';
import SplitPane from 'react-split-pane';

const SLIDE_PANEL_HORIZONTAL_MIN_SIZE = settings.APP_CONFIG.slidePanelHorizontalMinSize;
const SLIDE_PANEL_HORIZONTAL_MAX_SIZE = settings.APP_CONFIG.slidePanelHorizontalMaxSize;
const SLIDE_PANEL_VERTICAL_MIN_SIZE = settings.APP_CONFIG.slidePanelVerticalMinSize;
const SLIDE_PANEL_VERTICAL_MAX_SIZE = settings.APP_CONFIG.slidePanelVerticalMaxSize;

const Layout = ({
  classes, component1, component2, defaultSize, maxSize, minSize, split
}) => {
  // provide min and max sizing for layout styles
  const size = {
    horizontal: {
      min: minSize || SLIDE_PANEL_HORIZONTAL_MIN_SIZE,
      max: maxSize || SLIDE_PANEL_HORIZONTAL_MAX_SIZE
    },
    vertical: {
      min: minSize || SLIDE_PANEL_VERTICAL_MIN_SIZE,
      max: maxSize || SLIDE_PANEL_VERTICAL_MAX_SIZE
    }
  };

  return (
    <div className={classNames(classes, 'bhp-container')}>
      <SplitPane defaultSize={defaultSize} minSize={size[split].min} maxSize={size[split].max} split={split}>
        {component1}
        {component2}
      </SplitPane>
    </div>
  );
};

Layout.propTypes = {
  classes: PropTypes.string,
  defaultSize: PropTypes.string,
  component2: PropTypes.object.isRequired,
  component1: PropTypes.object.isRequired,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  split: PropTypes.string
};

Layout.defaultProps = {
  classes: '',
  defaultSize: '45%',
  maxSize: null,
  minSize: null,
  split: 'vertical'
};

export default Layout;
